import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { useMinerContext } from "../MinerContext";
import { MinerActions } from "../minerReducer";
import { useAuth } from "@utils/hooks/useAuth";

export default function useMinerRowMoreChartControl() {

  const auth = useAuth();
  const { miner, dispatchMiner } = useMinerContext();

  const onChangeStatus = (status: MINER_STATUSES_E) => {
    dispatchMiner({
      type: MinerActions.Status,
      payload: { state: status },
    });
  };

  return {
    isAdmin: auth.isAdmin,
    currentRole: auth.role,
    miner,
    onChangeStatus,
  }
}